"use client";
import { j as s } from "./jsx-runtime-CJ-St4mQ.mjs";
import { d as m } from "./List.style-BO8Br8D6.mjs";
import a from "./Typography.js";
import c from "./Box.js";
function j(t) {
  const { children: i, variant: l, className: n, primary: r, secondary: e, ...o } = t;
  return /* @__PURE__ */ s.jsxs(
    c,
    {
      className: m({
        class: n
      }),
      ...o,
      children: [
        r && /* @__PURE__ */ s.jsx(
          a,
          {
            render: /* @__PURE__ */ s.jsx("span", {}),
            variant: "body2",
            className: "block font-semi-bold tracking-wide",
            children: r
          }
        ),
        e && /* @__PURE__ */ s.jsx(a, { render: /* @__PURE__ */ s.jsx("span", {}), variant: "body1", className: "text-gray-600", children: e }),
        i
      ]
    }
  );
}
export {
  j as ListItemText,
  j as default
};
